import { NO_BUDGET } from '../static/constants.js';

let navigate;

export const setNavigator = (nav) => {
  navigate = nav;
};

export const navigateTo = (path, options) => {
  if (navigate) {
    navigate(path, options);
  } 
};


export const buildPath = (user, link = '') => {
  const orgId = user?.activeOrganization;
  const budgetId = user?.activeBudget?.id || NO_BUDGET;

  return `/${orgId}/${budgetId}${link ? `/${link}` : ''}`;
};
